import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';

export default function Manifesto() {
  const { t } = useI18n();
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-medium mb-6">Tikkun</p>
      <h1 className="font-display text-5xl md:text-6xl font-medium tracking-tight leading-tight">{t.manifesto.title}</h1>
      <p className="mt-6 text-lg text-muted-foreground max-w-2xl leading-relaxed">{t.manifesto.subtitle}</p>

      <ol className="mt-16 space-y-10">
        {t.principles.items.map((p, i) => (
          <motion.li
            key={i}
            initial={{ opacity: 0, x: -12 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.04 }}
            className="flex gap-6 pb-10 border-b border-border last:border-none"
            data-testid={`manifesto-item-${i}`}
          >
            <span className="font-mono text-sm text-brand-gold-dark dark:text-brand-gold pt-1 min-w-[3ch]">0{i + 1}</span>
            <div>
              <h2 className="font-display text-2xl md:text-3xl tracking-tight font-medium">{p.title}</h2>
              <p className="mt-3 text-muted-foreground text-lg leading-relaxed">{p.body}</p>
            </div>
          </motion.li>
        ))}
      </ol>

      <div className="mt-20 p-8 rounded-3xl bg-secondary border border-border">
        <p className="text-foreground text-lg leading-relaxed italic">{t.manifesto.close}</p>
      </div>
    </div>
  );
}
